<template>
  <section id="shopwrap">
    <description>Erweitern Sie den Shop um Funktionen, die wir exakt nach Ihrem Design implementieren.</description>
    <section>
      <section>
      <Swiper :maxslides="3">
        <tile checkbox-id="produktoptionen" heading="Konfigurator" input="checkbox" icon-id="produktoptionen" :contents="produktoptionenContent" :hints="produktoptionenHints" :input-disabled="disabledInputs" />
        <tile checkbox-id="downloadprodukte" heading="Downloads" input="checkbox" icon-id="downloadprodukte" :contents="downloadprodukteContent" :hints="downloadprodukteHints" :input-disabled="disabledInputs" />
        <tile checkbox-id="produktfilter" heading="Produktfilter" input="checkbox" icon-id="produktfilter" :contents="produktfilterContent" :hints="produktfilterHints" :input-disabled="disabledInputs" />
        <tile checkbox-id="affiliate" heading="Amazon Affiliate" input="checkbox" icon-id="affiliate" :contents="affiliateContent" :hints="affiliateHints" :input-disabled="disabledInputs" />
        <tile checkbox-id="sociallogin" heading="Login über Dritte" input="checkbox" icon-id="sociallogin" :contents="socialloginContent" :hints="socialloginHints" :input-disabled="disabledInputs" />
        <tile checkbox-id="paymentmethods" heading="Zahlungsmethoden" input="checkbox" icon-id="paymentmethods" :contents="paymentmethodsContent" :hints="paymentmethodsHints" :input-disabled="disabledInputs" />
      </Swiper>
      </section>
    </section>
    <controller next="/technisches" />
    <inclusive-footer />
    <how-to />
    <made />
    <tween-max v-if="false" />
  </section>
</template>

<script>
import TweenMax from 'gsap/TweenMax'
import Description from '@/components/Description.vue'
import Swiper from '@/components/Swiper.vue'
import Tile from '@/components/Tile.vue'
import Controller from '@/components/Controller.vue'
import HowTo from '@/components/HowTo.vue'
import InclusiveFooter from '@/components/InclusiveFooter.vue'
import Made from '@/components/Made.vue'
export default {
  name: 'shop',
  data: function () {
    return {
      produktoptionenContent: [
        { sentence: 'Konfigurierbare Produkte anbieten' },
        { sentence: 'Zum Beispiel Gravuren für Schmuck, Stoffarten für Kleidung oder Motorisierung für Maschinen' }
      ],
      produktoptionenHints: [
        { sentence: 'Die Konfigurationen können im Shop-System angelegt werden' },
        { sentence: 'Automatische Berechnung des Preises' }
      ],
      downloadprodukteContent: [
        { sentence: 'Produkte zum Herunterladen anbieten' },
        { sentence: 'Automatisiert Download-Links anbieten' }
      ],
      downloadprodukteHints: [
        { sentence: 'Automatisiert nach der Bestellung oder nach Zahlungseingang Download-Links anbieten' },
        { sentence: 'Tracken ob Download getätigt wurde' }
      ],
      produktfilterContent: [
        { sentence: 'Filter zum Sortieren der Produkte in der Übersicht' },
        { sentence: 'Beliebige Filtereigenschaften wie Größen oder Materialarten angeben' }
      ],
      produktfilterHints: [
        { sentence: 'Schafft vor allem bei vielen Produkten Übersicht' },
        { sentence: 'Filterbare Eigenschaften können den Produkten im CMS hinzugefügt werden' }
      ],
      affiliateContent: [
        { sentence: 'Produkte aus Amazon in den eigenen Shop einbinden' },
        { sentence: 'Weiterleitung über Amazon-Affiliate-Link' }
      ],
      affiliateHints: [
        { sentence: 'Geld bei jedem Verkauf durch Affiliate-Prämie verdienen' },
        { sentence: 'Angebot, Verkauf und Versand erfolgt durch Amazon oder seine Händler - der eigene Shop dient nur als Werbeplattform' }
      ],
      socialloginContent: [
        { sentence: 'Login via Google, Facebook oder Amazon anbieten' },
        { sentence: 'Hürde senken, auf Ihrer Seite einzukaufen' }
      ],
      socialloginHints: [
        { sentence: 'User müssen sich nicht auf der Website registrieren, sondern können sich direkt mit Ihren Accounts von Google, Facebook oder Amazon einloggen' }
      ],
      paymentmethodsContent: [
        { sentence: 'Zusätzlich AmazonPay, PayPal, Sofortüberweisung oder Kreditkarte als Zahlungsmethoden' },
        { sentence: 'Mindert die Hürde, dass Kunden bei Ihnen einkaufen' }
      ],
      paymentmethodsHints: [
        { sentence: 'Inklusive Standardzahlmethoden sind Überweisung und Barzahlung' }
      ]
    }
  },
  components: {
    Swiper,
    Tile,
    Controller,
    TweenMax,
    HowTo,
    InclusiveFooter,
    Description,
    Made
  },
  created: function () {
    if (!this.$root.items.find(item => item.id === 'onlineshop').status) {
      this.$router.push('templates')
    }
  },
  computed: {
    contentActive: function () {
      return this.$root.items.find(item => item.id === 'onlineshop').status
    },
    disabledInputs: function () {
      return !this.$root.items.find(item => item.id === 'onlineshop').status
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
#shopwrap {
  padding-top: 80px;
  #description {
    padding: 0 15px;
    p {
      font-size: 18px;
    }
  }
}
@media (min-height: 420px) {
  #shopwrap {
    padding-bottom: 107px;
  }
}
@media (min-height: 520px) {
  #shopwrap {
    padding-bottom: 127px;
  }
}
@media(min-width:767px) {
  #shopwrap {
    padding-top: 100px;
    #description {
      padding: 0 40px;
      p {
        font-size: 20px;
      }
    }
  }
}
</style>
